import React    from 'react';
import { Link } from 'react-router-dom';

import GalleryImage   from '../../../components/sliders/GallerySlider/components/GalleryImage';
import { useCatalog } from '../../../providers/catalog';

const CategoryGrid = function(props) {
  const {
          data,
          className,
          title,
        } = props;

  const { resetCatalog } = useCatalog();

  return (
    <div className={className}>
      <div className={'categoryGrid_title_container'}>
        <hr />
        <h2 className={'categoryGrid_title'}>{title}</h2>
        <hr />
      </div>
      <div className={'categoryGrid_container'}>
        {data.map((category, index) => (
          <Link
            to={category.link}
            className={'categoryGrid_item'}
            key={index}
            onClick={resetCatalog}
          >
            <div className={'image_container'}>
              <GalleryImage
                alt={category.alt}
                src={category.imgLink}
                size={351}
                type={'image'}
              />
            </div>
            <h3>{category.title}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryGrid;
